module.exports = __webpack_public_path__ + "static/assets/f51cb2d3812e1b0a54021de273c2dd2c.png";